import React, { useEffect, useState,useCallback } from "react";
import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import userAvatar from "../assets/img/img1.jpg";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";
export default function Header() {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [notifCount, setNotifCount] = useState(0);
  const handleLogout = () => {
    localStorage.removeItem("authEmployee");
    navigate("/login");
  };
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const fetchData = useCallback(async () => {
      try {
        const response = await post("/notifications");
        if (response.status === 200) {
          setNotifications(Array.isArray(response.data.lists) ? response.data.lists : []);
          setNotifCount(response.data.count);
        } else {
          showAlert("error", response.status, response.message);
        }
      } catch (err) {
        showAlert("error", "Unexpected Error", err.message);
      }
    }, [showAlert]);

  useEffect(() => {
    fetchData(); // initial call

    const interval = setInterval(() => {
      fetchData();
    }, 15000);

    return () => clearInterval(interval); // cleanup
  }, []);

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  }

  function NotificationList() {
    const notiList = notifications.map((item, key) => {
      return (
        <li className="list-group-item" key={key}>
          <div className="list-group-body">
            <p><b>{item.title}</b></p>
            <p>{item.message}</p>
            <span style={{"color":"#14317d"}}>{item.date_added}</span>
          </div>
        </li>
      )
    });

    return (
      <ul className="list-group" style={{ maxHeight: "300px", overflowY: "auto" }}>
        {notiList}
      </ul>
    );
  }

  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);

    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');
    }

  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin", skin);
    }
  };
  const authEmployee = localStorage.getItem("authEmployee");
  const employee_name = authEmployee ? JSON.parse(authEmployee).employee_name : null;
  const role_name = authEmployee ? JSON.parse(authEmployee).role_name : null;
  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4"><i className="ri-menu-2-fill"></i></Link>

      <div className="me-auto">
       
      </div>
      <Dropdown className="dropdown-notification ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <small>{notifCount}</small><i className="ri-notification-3-line"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f me--10-f">
          <div className="dropdown-menu-header">
            <h6 className="dropdown-menu-title">Notifications</h6>
          </div>

          {notifications?.length > 0 ? (
            NotificationList()
          ) : (
            <div className="dropdown-item text-muted">No notifications</div>
          )}

          <div className="dropdown-menu-footer">
          </div>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            <img src={userAvatar} alt="" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3"><img src={userAvatar} alt="" /></div>
            <h5 className="mb-1 text-dark fw-semibold">{employee_name}</h5>
            <p className="fs-sm text-secondary">{role_name}</p>

           
            <nav className="nav">
              <Link to="" onClick={handleLogout}><i className="ri-logout-box-r-line"></i> Log Out</Link>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}